/**
 * Header Mega Menu Slider
 * Custom Splide.js implementation for the mega menu product slider
 * This overrides the global makeSlideshow function for mega menu sliders
 */

// Initialize header sliders when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    initializeMegaMenuSliders();
});

// Re-initialize sliders when sections are loaded (for theme editor)
document.addEventListener('shopify:section:load', function (e) {
    initializeMegaMenuSliders(e.target);
});

function initializeMegaMenuSliders(container = document) {
    const headerSliders = container.querySelectorAll('.mega-menu__slider');

    headerSliders.forEach(slider => {
        if (!slider.dataset.headerSliderInitialized) {
            if (window.slideshows && window.slideshows[slider.id]) {
                window.slideshows[slider.id].destroy();
                delete window.slideshows[slider.id];
            }

            const splide = new window.Splide(slider, {
                autoWidth: true,
                perPage: 1,
                arrows: false,
                pagination: false,
                gap: '1rem',
                trimSpace: true,
                breakpoints: {
                    990: {
                        gap: '1.5rem'
                    },
                    768: {
                        gap: '1.25rem'
                    },
                    480: {
                        gap: '1rem'
                    }
                }
            });

            if (!window.slideshows) {
                window.slideshows = {};
            }
            window.slideshows[slider.id] = splide;

            splide.mount();
            slider.dataset.headerSliderInitialized = 'true';
        }
    });
}

const originalMakeSlideshow = window.makeSlideshow;
window.makeSlideshow = function (splideRoot) {
    if (splideRoot.classList.contains('mega-menu__slider')) {
        return;
    }

    if (originalMakeSlideshow) {
        originalMakeSlideshow(splideRoot);
    }
};